/* ============================================================
   BioActive+ drawer sync — assets/bac-drawer-sync.js

   The cart drawer (section 'bioactive-cart-drawer') is rendered by
   the server once, at page load. Every PDP sticky bar and buy box
   adds to the cart over AJAX, so unless that particular script
   re-renders the drawer itself, the drawer keeps showing the cart as
   it was when the page loaded: the new line reaches the header count
   and the checkout, but not the panel — and closing/reopening does
   not help, because opening only toggles a class. Reloading the page
   was the only fix.

   This watches for cart mutations (fetch and XHR) and does what the
   reload did: re-request that one section for the CURRENT url and
   swap its contents in. It also syncs when the drawer is opened, so
   an add made while it was closed is never missed.

   Deliberately defensive: literal commas in the sections parameter
   (an encoded comma returns nothing), and markup is only swapped in
   when it is non-empty, so a failed or partial response can never
   blank the drawer.
   ============================================================ */
(function () {
  'use strict';
  if (window.__bacSyncInit) return; window.__bacSyncInit = true;

  var SECTION = 'bioactive-cart-drawer';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/i;

  function host() { return document.querySelector('[data-bac-drawer-host]'); }

  function sectionUrl() {
    var search = window.location.search || '';
    return window.location.pathname + search + (search ? '&' : '?') + 'sections=' + SECTION;
  }

  var inFlight = null;
  function sync() {
    if (!host()) return Promise.resolve(false);
    if (inFlight) return inFlight;
    inFlight = fetch(sectionUrl(), {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var html = data && data[SECTION];
        if (typeof html !== 'string' || !html.trim()) return false;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-bac-drawer-content]');
        var cur = document.querySelector('[data-bac-drawer-content]');
        if (!fresh || !cur || !fresh.innerHTML.trim()) return false;
        cur.innerHTML = fresh.innerHTML;
        return true;
      })
      .catch(function () { return false; })
      .then(function (ok) { inFlight = null; return ok; });
    return inFlight;
  }
  window.__bacSyncDrawer = sync;

  var timer;
  function syncSoon(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      sync().then(function () { setTimeout(sync, 900); });
    }, delay || 250);
  }

  /* fetch() — used by every PDP script in this theme */
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
      var isCart = CART_RE.test(url);
      var p = _fetch.apply(this, arguments);
      if (isCart) { p.then(function () { syncSoon(250); }).catch(function () {}); }
      return p;
    };
  }

  /* XMLHttpRequest — for anything older, including app scripts */
  if (window.XMLHttpRequest && XMLHttpRequest.prototype.open) {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { if (CART_RE.test(String(url))) { this.addEventListener('load', function () { syncSoon(250); }); } } catch (e) {}
      return _open.apply(this, arguments);
    };
  }

  /* Opening the drawer from anywhere re-syncs it */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-bac-open], a.ba-iconbtn[aria-label="Cart"], #cart-icon-bubble, a[href$="/cart"]')) syncSoon(120);
  }, true);

  document.addEventListener('ba:cart:open', function () { syncSoon(120); });
  document.addEventListener('cart:refresh', function () { syncSoon(250); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
})();
